import { createRouter, createWebHashHistory } from 'vue-router';


const routes = [
    {
        path: '/hub',
        beforeEnter() { location.href = process.env.VUE_APP_URL_HUB },  
        component: {}  
    },
    {
        path: '/',
        name: 'inicio',   
        meta: {},            
        component: () => import('../pages/home.vue')
    },   
    {
        path: '/Confirmacion_cuenta_Activa',
        name: 'Confir_cuenta_Activa',
        meta: {},  
        component: () => import('../pages/Confirmacion_cuenta_Activa/Confirm_cuenta_activa.vue')
    },     
    {
        path: '/registro',
        name: 'registro',   
        meta: {},            
        component: () => import('../pages/registro/registro.vue')
    }, 
    {
        path: '/Reset_pswd',
        name: 'Reset_pswd',   
        meta: {},            
        component: () => import('../pages/Reset_pswd/Reset_pswd.vue')
    }, 
    {
        path: '/confirmacion_pswd',
        name: 'confirmacion_pswd',
        component: () => import('../pages/confirmacion_pswd/confirm_reset_pswd.vue')
    }, 
    {
        path: '/aviso_privacidad',
        name: 'aviso_privacidad',
        component: () => import('../pages/aviso_privacidad/aviso_privacidad.vue')
    }, 
    {
        path: '/condiciones_uso',
        name: 'condiciones_uso',
        component: () => import('../pages/condiciones_uso/condiciones_uso.vue')
    }, 
    {
        path: '/difusion',
        name: 'difusion',
        component: () => import('../pages/difusion/difusionCuadros.vue')
    }, 
      
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


export default router;


